import * as ng from 'angular';

export const PaginationComponent = {
  template: require('./pagination-component.html'),
  controller: class PaginationComponent {

    private filter: any;
    private pageNumber: number;
    private pageSize: number;
    private pageSizes: Array<number>;
    private pageItemsCount: number;
    private itemsCount: number;
    private getItems: Function;

    private pageMax: number;

    private selectedPage: number;

    constructor() {
      this.pageMax = 1;
    }

    $onChanges(onChangesObj: ng.IOnChangesObject): void {
      this.pageMax = Math.floor(this.itemsCount / this.pageSize);
      this.pageMax = this.pageMax + (this.itemsCount % this.pageSize > 0 ? 1 : 0);
    }

    getItemsForPage(page: number) {
      this.filter.pageNumber = page;
      this.selectedPage = page;
      this.getItems();
    }

    getPage(num: number) {
      if (num > this.pageMax) {
        num = this.pageMax;
      }
      if (num < 0) {
        num = 0;
      }
      this.getItemsForPage(num);
    }

    getFirstPage() {
      this.getItemsForPage(0);
    }

    getPreviousPage() {
      this.filter.pageNumber -= 1;
      if (this.filter.pageNumber < 0) {
        this.filter.pageNumber = 0;
      }
      this.getItemsForPage(this.filter.pageNumber);
    }

    getNextPage() {
      this.filter.pageNumber += 1;
      if (this.filter.pageNumber > this.pageMax) {
        this.filter.pageNumber = this.pageMax;
      }
      this.getItemsForPage(this.filter.pageNumber);
    }

    getLastPage() {
      return this.getItemsForPage(this.pageMax);
    }

    getSummary(): string {
      let firstIndex = this.pageNumber === 0 ? 1 : (this.pageNumber - 1) * this.pageSize + 1;
      let lastIndex = this.pageNumber === 0 ? this.pageSize : (this.pageNumber - 1) * this.pageSize + this.pageItemsCount;
      return `${firstIndex} - ${lastIndex} di ${this.itemsCount}`;
    }

    showPagination(): boolean {
      return this.pageMax > 1;
    }

    isLeftNavigationDisabled(): boolean {
      return this.pageNumber <= 1;
    }

    isRightNavigationDisabled(): boolean {
      return this.pageNumber >= this.pageMax;
    }

    isSelectedPageSize(pageSize: number): boolean {
      return this.pageSize === pageSize;
    }

    setPageSize(pageSize: number): void {
      this.filter.pageSize = pageSize;
      this.filter.pageNumber = 1;
      this.getItems();
    }

    showPageSizeSelector(): boolean {
      return this.itemsCount > this.pageSize;
    }

    getSummaryWithoutPagination(): string {
      if (this.pageItemsCount === 1) {
        return `1 documento di 1`;
      }
      return `${this.pageItemsCount} documenti di ${this.pageItemsCount}`;
    }
  },
  bindings: {
    filter: '=',
    pageNumber: '=',
    pageSize: '=',
    pageSizes: '<',
    pageItemsCount: '<',
    itemsCount: '=',
    getItems: '=',
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/pagination-component/pagination-component.ts